import { cx } from "class-variance-authority";
import NextLink, { type LinkProps as NextLinkProps } from "next/link";
import type { PropsWithChildren } from "react";

import { uiOutlineClass } from "@/components/ui/global/outline";

type LinkProps = PropsWithChildren<NextLinkProps> & {
  className?: string;
  id?: string;
  target?: string;
};

export const Link = (props: LinkProps) => {
  return (
    <NextLink
      {...props}
      className={cx(
        uiOutlineClass,
        "text-primary-300 underline focus-visible:outline-secondary-200",
        "hover:text-secondary-200 focus-visible:text-secondary-200 active:text-secondary-100",
        props.className,
      )}
    />
  );
};
